<div class="right-side-bar right-side-bar-files overflow-hidden pt-0 collapsed" style="width: 720px !important;">
  <div class="right-side-bar-body">
    <div class="row slider-header d-block">
      <div class="row mx-0">
        <div class="col px-0 d-flex justify-content-start">
          <div class="col px-0 align-self-center d-flex">
            <div class="d-flex">
              <lucide-icon name="folder" class="mr-1" size="16" [strokeWidth]="2"></lucide-icon>
              <span class="f-size-14 text-gray-900 font-weight-medium">Resources</span>
            </div>
          </div>
          <!-- <div class="dropdown">
            <button class="float-right d-flex icon-no-border mr-2 dropdown-toggle border-0 bg-transparent" type="button"
              id="fileMainMenuDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="text-none mr-1">{{ currentTabNames[currentTab].displayName }}</span>
            </button>
            <div class="dropdown-menu mt-1" aria-labelledby="fileMainMenuDropdown">
              <ng-template ngFor let-i="index" let-item [ngForOf]="currentTabNames">
                <button class="dropdown-item" (click)="changeTab(item.id)" *ngIf="item.displayName && item.id !== currentTab">
                  <span class="f-size-15 text-none">{{item.displayName}}</span>
                </button>
              </ng-template>
            </div>
          </div> -->
        </div>
        <div class="col px-0 pl-0 d-flex justify-content-end" [hidden]="noDataForRecentFilesTab">
          <button type="button" class="d-flex h-36 btn-black text-white mr-2 dropdown-toggle rounded-8 px-2" (click)="addNewCategory()"
            aria-label="addCategory"
            *ngIf="(appSession.tenant.ownerId === appSession.user.id || appSession.user.canManageContentManagers) && currentTab === 1">
            <span class="f-size-14 d-flex text-white mr-1"><ibm-icon-add size="16" class="mr-1 fill-white"></ibm-icon-add>New category</span>
          </button>
          <div class="dropdown" *ngIf="currentTab === 2">
            <button class="d-flex h-36 btn-black text-white mr-2 dropdown-toggle rounded-8 px-2" type="button" id="fileAddDropdownMenuButton"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="f-size-14 d-flex mr-1"><ibm-icon-add size="16" class="mr-1 fill-white"></ibm-icon-add>New item</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right mt-1" aria-labelledby="fileAddDropdownMenuButton">
              <button class="dropdown-item" (click)="showAddItem(1)">
                <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg" class="w-20 mr-10" alt="word">
                <span class="f-size-14">Word</span>
              </button>
              <button class="dropdown-item" (click)="showAddItem(2)">
                <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg" class="w-20 mr-10" alt="excel">
                <span class="f-size-14">Excel</span>
              </button>
              <button class="dropdown-item" (click)="showAddItem(3)">
                <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg" class="w-20 mr-10"
                  alt="powerpoint">
                <span class="f-size-14 text-none">Powerpoint</span>
              </button>
              <button class="dropdown-item" (click)="showAddItem(5)">
                <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-2 ml-1 w-20"></lucide-icon>
                <span class="f-size-14 text-none">Create folder</span>
              </button>
              <button class="dropdown-item" (click)="triggerFileControl()"><lucide-icon name="monitor" [size]="16" [strokeWidth]="2" class="mr-2 ml-1 w-20"></lucide-icon><span class="f-size-14 text-none">Upload
                  files</span>
              </button>
              <input type="file" id="fileUploadOneDrive_MyFiles" style="display: none;" multiple
                (change)="fileInputChanged($event, false, level)" />
            </div>
          </div>
          <button type="button" class="float-right d-flex modal-header-icon mr-2" (click)="expandAllSections()"
            *ngIf="!isSectionOpen && currentTab === 1" aria-label="expand">
            <ibm-icon-maximize size="16"></ibm-icon-maximize>
          </button>
          <button type="button" class="float-right d-flex modal-header-icon mr-2" (click)="collapseAllSections()"
            *ngIf="isSectionOpen && currentTab === 1" aria-label="collapse">
            <ibm-icon-minimize size="16"></ibm-icon-minimize>
          </button>
          <button type="button" class="float-right d-flex modal-header-icon mr-2" (click)="openContentManagers()"
            aria-label="settings"
            *ngIf="(appSession.tenant.ownerId === appSession.user.id || appSession.user.canManageContentManagers) && currentTab === 1">
            <ibm-icon-settings size="16"></ibm-icon-settings>
          </button>
          <button type="button" class="float-right d-flex modal-header-icon mr-2" (click)="showSelectAll()"
            aria-label="SelectMyFiles_FS" *ngIf="!isShowSelectAll && currentTab === 2">
            <ibm-icon-checkbox-checked size="16"></ibm-icon-checkbox-checked>
          </button>
          <button type="button" class="float-right d-flex modal-header-icon mr-2" [ngClass]="{'bg-selected' : isWordChecked || isExcelChecked || isPPChecked || isPDFChecked}" data-toggle="modal"
            data-target="#filterFiles" *ngIf="currentTab === 4" (click)="openFilter()" aria-label="collapse">
            <ibm-icon-filter size="16" *ngIf="!isWordChecked && !isExcelChecked && !isPPChecked && !isPDFChecked"></ibm-icon-filter>
            <ibm-icon-filter-remove size="16" *ngIf="isWordChecked || isExcelChecked || isPPChecked || isPDFChecked"></ibm-icon-filter-remove>
          </button>
        </div>
        <div class="col-auto px-0">
          <!-- <button type="button" class="float-right d-flex modal-header-icon" (click)="closeFiles()" aria-label="Close">
            <ibm-icon-close size="16"></ibm-icon-close>
          </button> -->
          <button type="button" class="d-flex h-32 w-32 text-gray-600 hover:text-red-600 hover:bg-red-50 border-2 border-gray-300 hover:border-red-500 transition-all rounded-8 bg-background justify-content-center"
            (click)="closeFiles()" aria-label="Close">
            <lucide-icon name="x" size="16" [strokeWidth]="2"></lucide-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="row pt-10" style="background-color: #fafafa !important;">
      <div class="col h-100 px-0 pr-1">
        <div class="h-100" id="Document" role="tabpanel" aria-labelledby="Document-tab">
          <div class="tab-content vh-100 pt-3" [hidden]="!isAccLinked">
            <div class="search fileSearch mb-2 search-bar mx-3">
              <div class="input-group">
                <div class="input-group-prepend h-100">
                  <div class="input-group-text">
                    <lucide-icon name="search" [size]="16" [strokeWidth]="2" class="text-medium"></lucide-icon>
                  </div>
                </div>
                <input type="text" class="form-control rounded-8 text-left bg-pure-white"
                  [placeholder]="currentTab === 4 ? 'Search files' : (currentTab === 1 ? 'Search team drive' : (currentTab === 2 ? 'Search my files' : (currentTab === 3 ? 'Search sites' : 'Search')))"
                  (input)="applySearchFiles()" [(ngModel)]="searchText" autocomplete="nope">
                <div class="input-group-append h-100" style="display: none;">
                  <button (click)="removeSearch()" class="input-group-text btn btn-link text-decoration-none px-10">
                    <ibm-icon-close size="16" class="fill-medium"></ibm-icon-close></button>
                </div>
              </div>
            </div>
            <div class="tab-pane files-list" [ngClass]="{'active':  currentTab === 4}" role="tabpanel" id="Files"
              aria-labelledby="Files-tab">
              <perfect-scrollbar [config]="config" (psYReachEnd)="getMoreRecentFiles($event)">
                <div class="px-3 mt-10">
                  <div class="row mt-10" *ngIf="todayFiles.length !== 0 && !isHideToday">
                    <div class="col">
                      <a href="javascript:;"
                        class="btn text-vf-medium text-decoration-none cursor-default f-size-13 w-100 rounded-0 text-left px-0 font-weight-semibold">
                        Today
                      </a>
                    </div>
                  </div>
                  <div class="card-section" *ngIf="todayFiles.length > 0 && !isHideToday">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <ng-template ngFor let-i="index" let-lData [ngForOf]="todayFiles">
                        <li class="list-group-item cursor-pointer" (click)="openFile($event, lData.webUrl)"
                          [hidden]="lData.isHide">
                          <div class="card-wrapper">
                            <div class="col d-flex px-0 justify-content-center hide-on-moving pb-02">
                              <vf-file-icon [obj]="lData" [isSemibold]="true"></vf-file-icon>
                            </div>
                            <div class="col-10 px-0 d-flex">
                              <div class="ml-0 flex-nowrap">
                                <a target="_blank"
                                  class="f-size-14 font-weight-500 overflow-wrap-anywhere">{{lData.name}}
                                </a>
                              </div>
                            </div>
                            <div class="col d-flex px-0 justify-content-end">
                              <div class="dropdown">
                                <button class="btn p-05 btn-project-link-more" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" (click)="closeNestedDropdown();">
                                  <ibm-icon-overflow-menu-vertical size="16"></ibm-icon-overflow-menu-vertical>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="fileAddDropdownMenuButton">
                                  <button class="dropdown-item" *ngIf="lData.driveId && lData.folderId"
                                    (click)="openInM365(lData)">
                                    <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                    <span>Open location</span>
                                  </button>
                                  <button class="dropdown-item" [disabled]="isSaving"
                                    (click)="addFilesToShortcut(lData)">
                                    <ibm-icon-movement size="16" class="mr-2"></ibm-icon-movement>
                                    <span>Add to favorites</span>
                                  </button>
                                  <button class="dropdown-item" (click)="addFileTaskToMyDay(lData, 0)">
                                    <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                    <span>Add to my day</span>
                                  </button>
                                  <!-- <div #nestedDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                    <button role="menuitem" dropdownToggle class="dropdown-item pr-2" *ngIf="userSectionData.length > 1" type="button" (click)="$event.stopPropagation()">
                                      <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                      <span>Add to my day</span>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                      <a role="menuitem" class="dropdown-item" href="javascript:;" *ngFor="let section of userSectionData"
                                        (click)="addFileTaskToMyDay(lData, section.sectionId)">
                                        <span class="align-middle">{{section.sectionName}}</span>
                                      </a>
                                    </div>
                                  </div> -->
                                  <!-- <button class="dropdown-item" (click)="addFileTaskToDoLater(lData)">
                                    <ibm-icon-time size="16" class="mr-2"></ibm-icon-time>
                                    <span>Do later</span>
                                  </button> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                  <div class="row mt-10" *ngIf="yesterdayFiles.length !== 0 && !isHideYesterday">
                    <div class="col">
                      <a href="javascript:;"
                        class="btn text-vf-medium text-decoration-none cursor-default f-size-13 w-100 rounded-0 text-left px-0 font-weight-semibold">
                        Yesterday
                      </a>
                    </div>
                  </div>
                  <div class="card-section" *ngIf="yesterdayFiles.length > 0 && !isHideYesterday">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <ng-template ngFor let-i="index" let-lData [ngForOf]="yesterdayFiles">
                        <li class="list-group-item cursor-pointer" (click)="openFile($event, lData.webUrl)"
                          [hidden]="lData.isHide">
                          <div class="card-wrapper">
                            <div class="col d-flex px-0 justify-content-center pb-02">
                              <vf-file-icon [obj]="lData" [isSemibold]="true"></vf-file-icon>
                            </div>
                            <div class="col-10 px-0 d-flex">
                              <div class="ml-0 flex-nowrap">
                                <a target="_blank"
                                  class="f-size-14 font-weight-500 overflow-wrap-anywhere">{{lData.name}}
                                </a>
                              </div>
                            </div>
                            <div class="col d-flex px-0 justify-content-end">
                              <div class="dropdown">
                                <button class="btn p-05 btn-project-link-more" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" (click)="closeNestedDropdown();">
                                  <ibm-icon-overflow-menu-vertical size="16"></ibm-icon-overflow-menu-vertical>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="fileAddDropdownMenuButton">
                                  <button class="dropdown-item" *ngIf="lData.driveId && lData.folderId"
                                    (click)="openInM365(lData)">
                                    <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                    <span>Open location</span>
                                  </button>
                                  <button class="dropdown-item" [disabled]="isSaving"
                                    (click)="addFilesToShortcut(lData)">
                                    <ibm-icon-movement size="16" class="mr-2"></ibm-icon-movement>
                                    <span>Add to favorites</span>
                                  </button>
                                  <button class="dropdown-item" (click)="addFileTaskToMyDay(lData, 0)">
                                    <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                    <span>Add to my day</span>
                                  </button>
                                  <!-- <div #nestedDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                    <button role="menuitem" dropdownToggle class="dropdown-item pr-2" *ngIf="userSectionData.length > 1" type="button" (click)="$event.stopPropagation()">
                                      <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                      <span>Add to my day</span>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                      <a role="menuitem" class="dropdown-item" href="javascript:;" *ngFor="let section of userSectionData"
                                        (click)="addFileTaskToMyDay(lData, section.sectionId)">
                                        <span class="align-middle">{{section.sectionName}}</span>
                                      </a>
                                    </div>
                                  </div> -->
                                  <!-- <button class="dropdown-item" (click)="addFileTaskToDoLater(lData)">
                                    <ibm-icon-time size="16" class="mr-2"></ibm-icon-time>
                                    <span>Do later</span>
                                  </button> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                  <div class="row mt-10" *ngIf="earlyThisWeekFiles.length !== 0 && !isHideEarly">
                    <div class="col">
                      <a href="javascript:;"
                        class="btn text-vf-medium text-decoration-none cursor-default f-size-13 w-100 rounded-0 text-left px-0 font-weight-semibold">
                        Early this week
                      </a>
                    </div>
                  </div>
                  <div class="card-section" *ngIf="earlyThisWeekFiles.length > 0 && !isHideEarly">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <ng-template ngFor let-i="index" let-lData [ngForOf]="earlyThisWeekFiles">
                        <li class="list-group-item cursor-pointer" (click)="openFile($event, lData.webUrl)"
                          [hidden]="lData.isHide">
                          <div class="card-wrapper">
                            <div class="col d-flex px-0 justify-content-center pb-02">
                              <vf-file-icon [obj]="lData" [isSemibold]="true"></vf-file-icon>
                            </div>
                            <div class="col-10 px-0 d-flex">
                              <div class="ml-0 flex-nowrap">
                                <a target="_blank"
                                  class="f-size-14 font-weight-500 overflow-wrap-anywhere">{{lData.name}}
                                </a>
                              </div>
                            </div>
                            <div class="col d-flex px-0 justify-content-end">
                              <div class="dropdown">
                                <button class="btn p-05 btn-project-link-more" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" (click)="closeNestedDropdown();">
                                  <ibm-icon-overflow-menu-vertical size="16"></ibm-icon-overflow-menu-vertical>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="fileAddDropdownMenuButton">
                                  <button class="dropdown-item" *ngIf="lData.driveId && lData.folderId"
                                    (click)="openInM365(lData)">
                                    <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                    <span>Open location</span>
                                  </button>
                                  <button class="dropdown-item" [disabled]="isSaving"
                                    (click)="addFilesToShortcut(lData)">
                                    <ibm-icon-movement size="16" class="mr-2"></ibm-icon-movement>
                                    <span>Add to favorites</span>
                                  </button>
                                  <button class="dropdown-item" (click)="addFileTaskToMyDay(lData, 0)">
                                    <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                    <span>Add to my day</span>
                                  </button>
                                  <!-- <div #nestedDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                    <button role="menuitem" dropdownToggle class="dropdown-item pr-2" *ngIf="userSectionData.length > 1" type="button" (click)="$event.stopPropagation()">
                                      <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                      <span>Add to my day</span>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                      <a role="menuitem" class="dropdown-item" href="javascript:;" *ngFor="let section of userSectionData"
                                        (click)="addFileTaskToMyDay(lData, section.sectionId)">
                                        <span class="align-middle">{{section.sectionName}}</span>
                                      </a>
                                    </div>
                                  </div> -->
                                  <!-- <button class="dropdown-item" (click)="addFileTaskToDoLater(lData)">
                                    <ibm-icon-time size="16" class="mr-2"></ibm-icon-time>
                                    <span>Do later</span>
                                  </button> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                  <div class="row mt-10" *ngIf="lastWeekFiles.length !== 0 && !isHideLastWeek">
                    <div class="col">
                      <a href="javascript:;"
                        class="btn text-vf-medium text-decoration-none cursor-default f-size-13 w-100 rounded-0 text-left px-0 font-weight-semibold">
                        Last week
                      </a>
                    </div>
                  </div>
                  <div class="card-section" *ngIf="lastWeekFiles.length > 0 && !isHideLastWeek">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <ng-template ngFor let-i="index" let-lData [ngForOf]="lastWeekFiles">
                        <li class="list-group-item cursor-pointer" (click)="openFile($event, lData.webUrl)"
                          [hidden]="lData.isHide">
                          <div class="card-wrapper">
                            <div class="col d-flex px-0 justify-content-center pb-02">
                              <vf-file-icon [obj]="lData" [isSemibold]="true"></vf-file-icon>
                            </div>
                            <div class="col-10 px-0 d-flex">
                              <div class="ml-0 flex-nowrap">
                                <a target="_blank"
                                  class="f-size-14 font-weight-500 overflow-wrap-anywhere">{{lData.name}}
                                </a>
                              </div>
                            </div>
                            <div class="col d-flex px-0 justify-content-end">
                              <div class="dropdown">
                                <button class="btn p-05 btn-project-link-more" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" (click)="closeNestedDropdown();">
                                  <ibm-icon-overflow-menu-vertical size="16"></ibm-icon-overflow-menu-vertical>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="fileAddDropdownMenuButton">
                                  <button class="dropdown-item" *ngIf="lData.driveId && lData.folderId"
                                    (click)="openInM365(lData)">
                                    <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                    <span>Open location</span>
                                  </button>
                                  <button class="dropdown-item" [disabled]="isSaving"
                                    (click)="addFilesToShortcut(lData)">
                                    <ibm-icon-movement size="16" class="mr-2"></ibm-icon-movement>
                                    <span>Add to favorites</span>
                                  </button>
                                  <button class="dropdown-item" (click)="addFileTaskToMyDay(lData, 0)">
                                    <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                    <span>Add to my day</span>
                                  </button>
                                  <!-- <div #nestedDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                    <button role="menuitem" dropdownToggle class="dropdown-item pr-2" *ngIf="userSectionData.length > 1" type="button" (click)="$event.stopPropagation()">
                                      <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                      <span>Add to my day</span>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                      <a role="menuitem" class="dropdown-item" href="javascript:;" *ngFor="let section of userSectionData"
                                        (click)="addFileTaskToMyDay(lData, section.sectionId)">
                                        <span class="align-middle">{{section.sectionName}}</span>
                                      </a>
                                    </div>
                                  </div> -->
                                  <!-- <button class="dropdown-item" (click)="addFileTaskToDoLater(lData)">
                                    <ibm-icon-time size="16" class="mr-2"></ibm-icon-time>
                                    <span>Do later</span>
                                  </button> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                  <div class="row mt-10" *ngIf="olderFiles.length !== 0 && !isHideOlder">
                    <div class="col">
                      <a href="javascript:;"
                        class="btn text-vf-medium text-decoration-none cursor-default f-size-13 w-100 rounded-0 text-left px-0 font-weight-semibold">
                        Older
                      </a>
                    </div>
                  </div>
                  <div class="card-section" *ngIf="olderFiles.length > 0 && !isHideOlder">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <ng-template ngFor let-i="index" let-lData [ngForOf]="olderFiles">
                        <li class="list-group-item cursor-pointer" (click)="openFile($event, lData.webUrl)"
                          [hidden]="lData.isHide">
                          <div class="card-wrapper">
                            <div class="col d-flex px-0 justify-content-center pb-02">
                              <vf-file-icon [obj]="lData" [isSemibold]="true"></vf-file-icon>
                            </div>
                            <div class="col-10 px-0 d-flex">
                              <div class="ml-0 flex-nowrap">
                                <a target="_blank"
                                  class="f-size-14 font-weight-500 overflow-wrap-anywhere">{{lData.name}}
                                </a>
                              </div>
                            </div>
                            <div class="col d-flex px-0 justify-content-end">
                              <div class="dropdown">
                                <button class="btn p-05 btn-project-link-more" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" (click)="closeNestedDropdown();">
                                  <ibm-icon-overflow-menu-vertical size="16"></ibm-icon-overflow-menu-vertical>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="fileAddDropdownMenuButton">
                                  <button class="dropdown-item" *ngIf="lData.driveId && lData.folderId"
                                    (click)="openInM365(lData)">
                                    <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                    <span>Open location</span>
                                  </button>
                                  <button class="dropdown-item" [disabled]="isSaving"
                                    (click)="addFilesToShortcut(lData)">
                                    <ibm-icon-movement size="16" class="mr-2"></ibm-icon-movement>
                                    <span>Add to favorites</span>
                                  </button>
                                  <button class="dropdown-item" (click)="addFileTaskToMyDay(lData, 0)">
                                    <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                    <span>Add to my day</span>
                                  </button>
                                  <!-- <div #nestedDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                    <button role="menuitem" dropdownToggle class="dropdown-item pr-2" *ngIf="userSectionData.length > 1" type="button" (click)="$event.stopPropagation()">
                                      <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                      <span>Add to my day</span>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                      <a role="menuitem" class="dropdown-item" href="javascript:;" *ngFor="let section of userSectionData"
                                        (click)="addFileTaskToMyDay(lData, section.sectionId)">
                                        <span class="align-middle">{{section.sectionName}}</span>
                                      </a>
                                    </div>
                                  </div> -->
                                  <!-- <button class="dropdown-item" (click)="addFileTaskToDoLater(lData)">
                                    <ibm-icon-time size="16" class="mr-2"></ibm-icon-time>
                                    <span>Do later</span>
                                  </button> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                  <div [hidden]="!isPinnedFilesLoading" class="my-10">
                    <div class="skeleton skeleton-tile"></div>
                  </div>
                  <div [hidden]="!isLoadingFiles" class="my-10">
                    <div class="skeleton skeleton-tile"></div>
                    <div class="skeleton skeleton-tile"></div>
                    <div class="skeleton skeleton-tile"></div>
                  </div>
                  <div class="mt-5"
                    *ngIf="noMatchingRecentSearch && isSearchApplied && onedriveRecentData?.length === 0 && pinnedFilesData.length === 0 && !isLoadingFiles">
                    <h2 class="text-center text-vf-dark font-weight-semibold f-size-14">
                      No results found.
                    </h2>
                    <p class="f-size-13 text-center pb-5 text-vf-light">
                      We can't find anything matching your search terms.
                    </p>
                  </div>
                  <div class="mt-5"
                    *ngIf="onedriveRecentData.length === 0 && pinnedFilesData.length === 0 && !isSearchApplied && !isLoadingFiles">
                    <h2 class="text-center text-vf-dark font-weight-semibold f-size-14">
                      No recent files.
                    </h2>
                    <p class="f-size-13 text-center pb-5 text-vf-light font-weight-medium">
                      <input type="file" id="fileUploadOneDrive_MyFiles" style="display: none;" multiple
                        (change)="fileInputChanged($event, false, level)" />
                      <a href="javascript:;" class="text-blue-link cursor-pointer text-decoration-none"
                        (click)="triggerFileControl()">Upload</a> or
                      <a href="javascript:;" class="text-blue-link cursor-pointer text-decoration-none"
                        (click)="openCreateFileModal('word')">Create </a> your first document
                    </p>
                  </div>
                </div>
              </perfect-scrollbar>
            </div>
            <div class="tab-pane files-list" [ngClass]="{'active':  currentTab === 2}" role="tabpanel" id="My-files"
              aria-labelledby="My-files-tab">
              <div class="row select-all-action-bar-dark mx-3 mt-3 mb-2" *ngIf="isShowSelectAll">
                <div class="col-auto pl-0 d-flex f-size-13 justify-content-start text-white pr-4" *ngIf="noOfSelectedItems > 0">
                  <!-- <span>({{noOfSelectedItems}}) Selected</span> &nbsp;|&nbsp;
                  <span class="cursor-pointer text-blue-sky" (click)="clearAllSelectedItems()">Clear</span> -->
                  <div class="custom-control custom-checkbox custom-checkbox-success select-multiple-checkbox">
                    <input type="checkbox" class="custom-control-input" id="Select-All-Files"
                      [checked]="isAllItemsSelected" (change)="clearAllSelectedItems()">
                    <label class="custom-control-label pt-05 text-white" for="Select-All-Files">
                      Selected ({{noOfSelectedItems}})
                    </label>
                  </div>
                </div>
                <div class="col-auto pl-0 d-flex f-size-13 justify-content-start text-white pr-4" *ngIf="noOfSelectedItems === 0">
                  <div class="custom-control custom-checkbox custom-checkbox-success select-multiple-checkbox">
                    <input type="checkbox" class="custom-control-input" id="Select-All-Files"
                      [checked]="isAllItemsSelected" (change)="selectAllItems()">
                    <label class="custom-control-label pt-05 text-white" for="Select-All-Files">
                      Select all
                    </label>
                  </div>
                </div>
                <div class="col pr-0 d-flex justify-content-end border-left">
                  <div class="dropdown">
                    <button class="float-right btn tk-proxima-nova action-bar-button f-size-13 dropdown-toggle d-flex" type="button"
                      id="MoveToMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <lucide-icon name="corner-up-right" [size]="12" [strokeWidth]="2" class="mr-2"></lucide-icon>
                      <span class="mr-2">Move to</span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right mt-1" aria-labelledby="MoveToMenuButton">
                      <button class="dropdown-item" (click)="moveWithinThisFolder()">
                        <!-- <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon> -->
                        <ibm-icon-folder-details size="16" class="mr-2 icon-15"></ibm-icon-folder-details>
                        <span class="f-size-14">Move within this folder/library</span>
                      </button>
                      <button class="dropdown-item" (click)="moveToDiffLocation()">
                        <img src="https://cdn.trovve.com/vfapp/images/app-icons/Onedrive.svg" class="w-15 mr-2"
                          alt="OneDrive / SharePoint">
                        <span class="f-size-14">Move to different location</span>
                      </button>
                    </div>
                  </div>
                  <div class="dropdown">
                    <button class="float-right btn tk-proxima-nova action-bar-button f-size-13 ml-2 dropdown-toggle d-flex" type="button"
                      id="CopyToMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <lucide-icon name="copy" [size]="12" [strokeWidth]="2" class="mr-2"></lucide-icon>
                      <span class="mr-2">Copy to</span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right mt-1" aria-labelledby="CopyToMenuButton">
                      <button class="dropdown-item" (click)="copyWithinThisFolder()">
                        <!-- <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon> -->
                        <ibm-icon-folder-details size="16" class="mr-2 icon-15"></ibm-icon-folder-details>
                        <span class="f-size-14">Copy within this folder/library</span>
                      </button>
                      <button class="dropdown-item" (click)="copyToDiffLocation()">
                        <img src="https://cdn.trovve.com/vfapp/images/app-icons/Onedrive.svg" class="w-15 mr-2"
                          alt="OneDrive / SharePoint">
                        <span class="f-size-14">Copy to different location</span>
                      </button>
                    </div>
                  </div>
                  <button class="float-right btn tk-proxima-nova action-bar-button f-size-13 ml-2 d-flex" type="button"
                    id="DeleteSelectedItems_btn" (click)="deleteSelectedItems()">
                    <!-- <lucide-icon name="trash-2" [size]="12" [strokeWidth]="2" class="mr-2"></lucide-icon> -->
                    <ibm-icon-trash-can size="16" class="fill-white mr-2 icon-13"></ibm-icon-trash-can>
                    Delete
                  </button>
                  <button class="float-right btn p-1 tk-proxima-nova text-white border rounded-8 ml-3" type="button"
                    id="closeSelectAllBar" (click)="hideSelectAllBar()">
                    <!-- <lucide-icon name="x" [size]="10" [strokeWidth]="2" class="ml-2"></lucide-icon> -->
                    <ibm-icon-close size="16" class="fill-white icon-14"></ibm-icon-close>
                  </button>
                </div>
              </div>
              <perfect-scrollbar [config]="config" (psYReachEnd)="getMoreMyFiles($event)">
                <div class="px-3" [ngClass]="{'mt-10': isShowSelectAll === true, 'mt-20': isShowSelectAll === false}">
                  <div class="card-section mb-3" *ngIf="isShowAddItem">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <li class="list-group-item cursor-pointer d-flex">
                        <div class="card-wrapper">
                          <div class="col px-0 d-flex justify-content-center pl-2">
                            <div class="dropdown">
                              <button class="float-right btn pl-0 tk-proxima-nova text-medium dropdown-toggle"
                                type="button" id="selectDocTypeMenu1" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                  *ngIf="selectedDocType === 1" class="w-20 mr-10" alt="word">
                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                  *ngIf="selectedDocType === 2" class="w-20 mr-10" alt="excel">
                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                  *ngIf="selectedDocType === 3" class="w-20 mr-10" alt="powerpoint">
                                <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10" *ngIf="selectedDocType === 5"></lucide-icon>
                              </button>
                              <div class="dropdown-menu dropdown-menu-right mt-1" aria-labelledby="selectDocTypeMenu1">
                                <button class="dropdown-item" (click)="selectDocType(1)">
                                  <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                    class="w-20 mr-10" alt="word">
                                  <span class="f-size-14">Word</span>
                                </button>
                                <button class="dropdown-item" (click)="selectDocType(2)">
                                  <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                    class="w-20 mr-10" alt="excel">
                                  <span class="f-size-14">Excel</span>
                                </button>
                                <button class="dropdown-item" (click)="selectDocType(3)">
                                  <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                    class="w-20 mr-10" alt="powerpoint">
                                  <span class="f-size-14 text-none">Powerpoint</span>
                                </button>
                                <button class="dropdown-item" (click)="selectDocType(5)">
                                  <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon>
                                  <span class="f-size-14 text-none">Create folder</span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-10 d-flex">
                            <span class="create-input d-flex" *ngIf="selectedDocType !== 5">
                              <span class="input-text create-file border-none" contenteditable=""
                                (keypress)="onNewFileKeyPress($event, false, level)"
                                (blur)="onNewFileBlur($event, false, level)"></span>
                            </span>
                            <span class="create-input d-flex" *ngIf="selectedDocType === 5">
                              <span class="input-text create-folder border-none" contenteditable=""
                                (keypress)="onNewFolderKeyPress($event, false, level)"
                                (blur)="onNewFolderBlur($event, false, level)"></span>
                            </span>
                          </div>
                          <div class="col d-flex px-0 justify-content-end">
                            <span class="f-size-14 text-blue cursor-pointer">
                              <span class="ml-1">Save</span>
                            </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div [hidden]="!isSharePointSitesLoading && !isSaving" class="my-10">
                    <div class="skeleton skeleton-tile"></div>
                  </div>
                  <div class="card-section"
                    *ngIf="driveItems.length > 0 && !isSharePointSitesLoading && !isFolderEmpty && !noResultFound">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <ng-template ngFor let-i="index" let-item [ngForOf]="driveItems">
                        <li class="list-group-item cursor-pointer" *ngIf="item.isShow">
                          <div class="card-wrapper">
                            <div class="col-auto pl-1 pr-10 d-flex justify-content-center" *ngIf="isShowSelectAll">
                              <div
                                class="custom-control custom-checkbox custom-checkbox-success select-multiple-checkbox">
                                <input type="checkbox" class="custom-control-input" id="Opt-{{item.id}}"
                                  [checked]="item.isSelected" (change)="selectItem(item)">
                                <label class="custom-control-label" for="Opt-{{item.id}}"></label>
                              </div>
                            </div>
                            <div class="col px-0 d-flex justify-content-center pb-02"
                              (click)="isShowSelectAll ? selectItem(item) : (item.extension === 'documentLibrary' || item.extension === 'folder' ? goToFolderFromMyFiles($event, item) : openFile($event, item.webUrl))">
                              <vf-file-icon [obj]="item" [isSemibold]="true"></vf-file-icon>
                            </div>
                            <div class="col-10 px-0 d-flex"
                              (click)="isShowSelectAll ? selectItem(item) : (item.extension === 'documentLibrary' || item.extension === 'folder' ? goToFolderFromMyFiles($event, item) : openFile($event, item.webUrl))">
                              <div class="ml-0 flex-nowrap">
                                <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14 font-weight-500"
                                  href="javascript:;"> {{item.name}}
                                </a>
                              </div>
                            </div>
                            <div class="col d-flex px-0 justify-content-end">
                              <div class="dropdown">
                                <button class="btn p-05 btn-project-link-more" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" (click)="toggleAction(item.id);closeNestedDropdown();closeCopyDropdown();closeMoveDropdown();">
                                  <ibm-icon-overflow-menu-vertical size="16"></ibm-icon-overflow-menu-vertical>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="fileAddDropdownMenuButton">
                                  <div *ngIf="currentItemId === item.id">
                                    <button class="dropdown-item" (click)="openLocationForMyFiles(item)">
                                      <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                      <span class="text-none">Open location</span>
                                    </button>
                                    <button class="dropdown-item" (click)="openAddToTask(item)">
                                      <ibm-icon-checkbox-checked size="16" class="mr-2"></ibm-icon-checkbox-checked>
                                      <span>Add to task</span>
                                    </button>
                                    <button class="dropdown-item" (click)="openLinkToProject(item)">
                                      <ibm-icon-portfolio size="16" class="mr-2"></ibm-icon-portfolio>
                                      <span>Add to {{projectLabelLower}}</span>
                                    </button>
                                    <button class="dropdown-item" [disabled]="isSaving"
                                      (click)="addMyFilesToShortcut(item, false)">
                                      <ibm-icon-movement size="16" class="mr-2"></ibm-icon-movement>
                                      <span>Add to favorites</span>
                                    </button>
                                    <button class="dropdown-item" (click)="addM365FileTaskToMyDay(item, false, 0)">
                                      <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                      <span>Add to my day</span>
                                    </button>
                                    <!-- <div #nestedDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                      <button role="menuitem" dropdownToggle class="dropdown-item pr-2" *ngIf="userSectionData.length > 1" type="button" (click)="closeCopyDropdown();closeMoveDropdown();$event.stopPropagation()">
                                        <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                        <span>Add to my day</span>
                                      </button>
                                      <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                        <a role="menuitem" class="dropdown-item" href="javascript:;" *ngFor="let section of userSectionData"
                                          (click)="addM365FileTaskToMyDay(item, false, section.sectionId)">
                                          <span class="align-middle">{{section.sectionName}}</span>
                                          
                                        </a>
                                      </div>
                                    </div> -->
                                    <!-- <button class="dropdown-item" (click)="addM365FileTaskToDoLater(item, false)">
                                      <ibm-icon-time size="16" class="mr-2"></ibm-icon-time>
                                      <span>Do later</span>
                                    </button> -->
                                    <div #copyDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                      <button role="menuitem" dropdownToggle class="dropdown-item" type="button" (click)="closeNestedDropdown();closeMoveDropdown();$event.stopPropagation()">
                                        <ibm-icon-copy size="16" class="mr-2"></ibm-icon-copy>
                                        <span class="align-middle">Copy to</span>
                                      </button>
                                      <div *dropdownMenu class="dropdown-menu dropdown-menu-right">
                                        <a role="menuitem" class="dropdown-item" href="javascript:;"
                                          (click)="copyWithinThisFolder(item)">
                                          <lucide-icon name="folder" [size]="16" class="icon-14 mr-2"></lucide-icon>
                                          <span class="align-middle">
                                            Copy within this folder/library
                                          </span>
                                        </a>
                                        <a role="menuitem" class="dropdown-item" href="javascript:;"
                                          (click)="copyToDiffLocation(item)">
                                          <img src="https://cdn.trovve.com/vfapp/images/app-icons/Onedrive.svg"
                                            class="w-15 mr-2" alt="OneDrive / SharePoint">
                                          <span class="align-middle">
                                            Copy to different location
                                          </span>
                                        </a>
                                      </div>
                                    </div>
                                    <div #moveDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                      <button role="menuitem" class="dropdown-item" type="button" dropdownToggle class="dropdown-item" type="button" (click)="closeNestedDropdown();closeCopyDropdown();$event.stopPropagation()">
                                        <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                        <span class="align-middle">Move to</span>
                                      </button>
                                      <div *dropdownMenu class="dropdown-menu dropdown-menu-right">
                                        <a role="menuitem" class="dropdown-item" href="javascript:;"
                                          (click)="moveWithinThisFolder(item)">
                                          <img src="https://cdn.trovve.com/trovve/folder-parent-medium.svg"
                                            class="w-15 mr-2" alt="OneDrive / SharePoint">
                                          <span class="align-middle">
                                            Move within this folder/library
                                          </span>
                                        </a>
                                        <a role="menuitem" class="dropdown-item" href="javascript:;"
                                          (click)="moveToDiffLocation(item)">
                                          <img src="https://cdn.trovve.com/vfapp/images/app-icons/Onedrive.svg"
                                            class="w-15 mr-2" alt="OneDrive / SharePoint">
                                          <span class="align-middle">
                                            Move to different location
                                          </span>
                                        </a>
                                      </div>
                                    </div>
                                    <button class="dropdown-item" (click)="copyToClipboard(item.webUrl)">
                                      <img src="https://cdn.trovve.com/trovve/Copy-link-light.svg" class="w-15 mr-2"
                                        alt="Copy file link">
                                      <span>Copy file link</span>
                                    </button>
                                    <button class="dropdown-item" (click)="openShareLinkModal(item)"
                                      *ngIf="item.parentReference.driveId && item.parentReference.driveId !== item.id">
                                      <ibm-icon-share size="16" class="mr-2"></ibm-icon-share>
                                      <span>Share</span>
                                    </button>
                                    <button class="dropdown-item" (click)="openRenameFileModal(item, false)">
                                      <ibm-icon-edit size="16" class="mr-2"></ibm-icon-edit>
                                      <span>Rename</span>
                                    </button>
                                    <button class="dropdown-item" (click)="delFileItem=item">
                                      <ibm-icon-trash-can size="16" class="mr-2"></ibm-icon-trash-can>
                                      <span>Delete</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                  <div class="row mt-5 d-flex justify-content-center"
                    *ngIf="isFolderEmpty && !isSharePointSitesLoading && !noResultFound">
                    <p class="f-size-14 text-center mb-0 text-vf-medium">
                      This folder is empty
                    </p>
                  </div>
                  <div class="mt-5" *ngIf="!isFolderEmpty && !isSharePointSitesLoading && noResultFound">
                    <h2 class="text-center text-vf-dark font-weight-semibold f-size-14">
                      No results found.
                    </h2>
                    <p class="f-size-13 text-center mb-0 text-vf-light font-weight-medium">
                      We can't find anything matching your search terms.
                    </p>
                  </div>
                </div>
              </perfect-scrollbar>
            </div>
            <div class="tab-pane files-list vh-155 domscroller teamDriveTabScroll"
              [ngClass]="{'active':  currentTab === 1}" role="tabpanel" id="Team-drive"
              aria-labelledby="Team-drive-tab">
              <div class="px-15 mt-10 ">
                <div class="row ml-3 mt-2 add-item border-bottom d-none mw-550" id="NewDriveCategoryForm">
                  <div class="col p-0 d-block">
                    <div class="ml-1 add-item">
                      <div class="col-12 m-0 p-0 d-flex align-items-center">
                        <input type="text" id="newDriveCategoryInput"
                          class="form-control bg-transparent rounded-0 border-0 pl-0" placeholder="Type a new category"
                          maxlength="100" [(ngModel)]="newDriveCategoryName" (blur)="onCategoryNameBlur()"
                          (keypress)="onCategoryKeyPress($event)">
                        <span class="w-175 f-size-14 cursor-pointer" (click)="onCategoryAdd()"
                          [ngClass]="!newDriveCategoryName || newDriveCategoryName === '' ? 'text-lighter' :'blue-txt'"><lucide-icon name="check" [size]="16" [strokeWidth]="2" class="mx-2"></lucide-icon>Add category
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div [hidden]="!isTeamDataLoading && !isDriveCategoryLoading" class="my-10">
                  <div class="skeleton skeleton-tile"></div>
                  <div class="skeleton skeleton-tile"></div>
                  <div class="skeleton skeleton-tile"></div>
                </div>
                <div id="TeamDriveSections" dragula="teamDriveCatDragula" [(dragulaModel)]="teamDriveCategoryData">
                  <ng-template ngFor let-ict="index" let-catgItem [ngForOf]="teamDriveCategoryData">
                    <div class="single-section mb-2 p-0" *ngIf="catgItem && !catgItem?.isHide && !isTeamDataLoading">
                      <div class="row category-row">
                        <div class="col d-flex mx-10 px-1 mb-2">
                          <a class="collapse-btn btn text-vf-dark font-weight-semibold text-left pl-0 py-0">
                            <div class="row">
                              <div class="col pr-0 text-vf-dark f-size-15 d-flex font-weight-semibold editTask"
                                [attr.data-target]="'#driveCat' + catgItem.id" data-toggle="collapse"
                                aria-expanded="true" [attr.aria-controls]="'driveCat' + catgItem.id" #firstEle
                                *ngIf="!catgItem.isEditing">
                                <div class="w-24"
                                  *ngIf="appSession.tenant.ownerId === appSession.user.id || appSession.user.canManageContentManagers">
                                  <ibm-icon-draggable size="16"
                                    class="w-15 fill-dark drive-category-sort hide-on-moving cursor-grab action-menu"></ibm-icon-draggable>
                                </div>
                                <lucide-icon [name]="firstEle.getAttribute('aria-expanded') ==='true' ? 'chevron-up' : 'chevron-down'" [size]="12" [strokeWidth]="2" class="mr-10 hide-on-moving"></lucide-icon>
                                <span class="f-size-20">{{catgItem.name}}</span>
                              </div>
                            </div>
                          </a>
                          <input type="text" id="EditCategory-{{catgItem.id}}"
                            class="form-control rounded-0 border-0 pl-1 ml-1 d-none edit-section-inline hide-on-moving"
                            [(ngModel)]="catgItem.name" (input)="onCategoryNameKeyPress($event, catgItem)"
                            (blur)="onCategNameBlur($event,catgItem)">
                          <span id="errorEditing-{{catgItem.id}}"
                            class="text-danger w-200 f-size-11 text-right d-none hide-on-moving">
                            <span *ngIf="!showBlankCategoryError">Category already exists!</span>
                            <span *ngIf="showBlankCategoryError">Category can't be blank.</span>
                          </span>
                        </div>
                        <div
                          class="col-auto px-0 d-flex align-items-end flex-column justify-content-between mr-15 task-action-dropdown">
                          <div class="dropdown float-right mb-2 hide-on-moving">
                            <button type="button" class="d-flex icon-no-border handle-list-buttons"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <ibm-icon-overflow-menu-horizontal size="16"></ibm-icon-overflow-menu-horizontal>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item d-flex" href="javascript:;" id="add-file-folder"
                                (click)="openFileSelector(catgItem.id)">
                                <ibm-icon-cloud size="16" class="mr-2"></ibm-icon-cloud>
                                <span class="f-size-14 text-none">Select Files</span>
                              </a>
                              <a class="dropdown-item d-flex" href="javascript:;" id="add-weblink"
                                (click)="addWeblink(catgItem.id)">
                                <lucide-icon name="globe" [size]="16" class="mr-2"></lucide-icon>
                                <span class="text-none">New web link</span>
                              </a>
                              <a class="dropdown-item d-flex" href="javascript:;" (click)="editCategory(catgItem)">
                                <ibm-icon-edit size="16" class="mr-2"></ibm-icon-edit>
                                <span class="text-none f-size-14">Edit category</span>
                              </a>
                              <a class="dropdown-item d-flex" href="javascript:;"
                                (click)="delDriveCategoryItem = catgItem">
                                <ibm-icon-trash-can size="16" class="mr-2"></ibm-icon-trash-can>
                                <span class="text-none f-size-14">Delete category</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="w-100 collapse show" id="driveCat{{catgItem.id}}">
                        <div class="card-section">
                          <ul class="list-group text-vf-dark project-file-list-group px-0"
                            [ngClass]="{'pb-1': catgItem.links?.length === 0}" id="catItemsDragula{{catgItem.id}}"
                            [attr.data-categoryId]="catgItem.id" dragula="teamDriveLinkDragula"
                            [(dragulaModel)]="catgItem.links">
                            <ng-template ngFor let-i="index" let-lData [ngForOf]="catgItem.links">
                              <li class="list-group-item cursor-pointer py-0"
                                (click)="lData.extension === 'documentLibrary' || lData.extension === 'folder' ? goToFolder($event, lData) : openFile($event, lData.url)"
                                [hidden]="lData?.isHide">
                                <div class="card-wrapper">
                                  <div class="w-16 d-flex">
                                    <ibm-icon-draggable size="16"
                                      class="w-15 fill-light category-links-sort hide-on-moving cursor-grab action-menu project-file-delete"
                                      *ngIf="appSession.tenant.ownerId === appSession.user.id || appSession.user.canManageContentManagers"></ibm-icon-draggable>
                                  </div>
                                  <div class="col d-flex px-0 justify-content-center hide-on-moving">
                                    <lucide-icon name="file-text" [size]="16" class="mr-10 text-medium"
                                      *ngIf="!getListExtension(lData.extension) && lData.extension !== 'folder' && lData.extension !== 'documentLibrary' && lData.driveId && !(lData.extension === 'jpg' || lData.extension === 'jpg' || lData.extension === 'jpeg' || lData.extension === 'gif' || lData.extension === 'bmp' || lData.extension === 'svg' || lData.extension === 'png')">
                                    </lucide-icon>
                                    <lucide-icon name="folder" [size]="16" class="mr-10 text-medium"
                                      *ngIf="lData.extension === 'folder'">
                                    </lucide-icon>
                                    <lucide-icon name="globe" [size]="16" class="mr-10 text-medium"
                                      *ngIf="!getListExtension(lData.extension) && lData.extension !== 'documentLibrary' && lData.extension !== 'folder' && !lData.driveId">
                                    </lucide-icon>
                                    <lucide-icon name="folder" [size]="16" class="mr-10 text-medium"
                                      *ngIf="lData.extension === 'documentLibrary'">
                                    </lucide-icon>
                                    <lucide-icon name="image" [size]="16" class="mr-10 text-medium"
                                      *ngIf="lData.extension === 'jpg' || lData.extension === 'jpg' || lData.extension === 'jpeg' || lData.extension === 'gif' || lData.extension === 'bmp' || lData.extension === 'svg' || lData.extension === 'png'">
                                    </lucide-icon>
                                    <img [src]="getListExtension(lData.extension) !== '' ? getListExtension(lData.extension): ''"
                                      *ngIf="getListExtension(lData.extension) && lData.extension !== 'documentLibrary' && lData.extension !== 'folder'"
                                      class="text-center w-15 mr-10">
                                  </div>
                                  <div class="col-10 px-0 d-flex">
                                    <div class="row ml-0 flex-nowrap editTask padding-while-move">
                                      <span class="f-size-14 font-weight-500 overflow-wrap-anywhere">
                                        {{lData.name}}
                                      </span>
                                    </div>
                                    <div class="row ml-0 d-flex pt-0 hide-on-moving" *ngIf="lData.isLocationLoading">
                                      <div class="col pl-0 badge-col">
                                        <div class="skeleton skeleton-text"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col d-flex px-0 justify-content-end hide-on-moving">
                                    <div class="dropdown">
                                      <button class="btn p-05 btn-project-link-more" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false" (click)="toggleAction(lData.id);closeNestedDropdown();">
                                        <ibm-icon-overflow-menu-vertical size="16"></ibm-icon-overflow-menu-vertical>
                                      </button>
                                      <div class="dropdown-menu dropdown-menu-right"
                                        aria-labelledby="fileAddDropdownMenuButton">
                                        <div *ngIf="currentItemId === lData.id">
                                          <button class="dropdown-item" (click)="openInM365(lData)">
                                            <ibm-icon-arrow-up-right size="16" class="mr-2"></ibm-icon-arrow-up-right>
                                            <span class="text-none">Open location</span>
                                          </button>
                                          <button class="dropdown-item" (click)="openAddToTaskFromTeamDrive(lData)">
                                            <ibm-icon-checkbox-checked size="16" class="mr-2"></ibm-icon-checkbox-checked>
                                            <span>Add to task</span>
                                          </button>
                                          <button class="dropdown-item" (click)="openLinkToProjectFromTeamDrive(lData)">
                                            <ibm-icon-portfolio size="16" class="mr-2"></ibm-icon-portfolio>
                                            <span>Add to {{projectLabelLower}}</span>
                                          </button>
                                          <button class="dropdown-item" (click)="addToShortcuts(lData)">
                                            <ibm-icon-movement size="16" class="mr-2"></ibm-icon-movement>
                                            <span>Add to favorites</span>
                                          </button>
                                          <button class="dropdown-item" (click)="addFileTaskToMyDay(lData, 0)">
                                            <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                            <span>Add to my day</span>
                                          </button>
                                          <!-- <div #nestedDropdown="bs-dropdown" dropdown triggers="click" container="body" placement="left">
                                            <button role="menuitem" dropdownToggle class="dropdown-item pr-2" *ngIf="userSectionData.length > 1" type="button"
                                               (click)="$event.stopPropagation()">
                                              <ibm-icon-sun size="16" class="mr-2"></ibm-icon-sun>
                                              <span>Add to my day</span>
                                            </button>
                                            <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                              <a role="menuitem" class="dropdown-item" href="javascript:;" *ngFor="let section of userSectionData"
                                                (click)="addFileTaskToMyDay(lData, section.sectionId)">
                                                <span class="align-middle">{{section.sectionName}}</span>
                                              </a>
                                            </div>
                                          </div> -->
                                          <!-- <button class="dropdown-item" (click)="addFileTaskToDoLater(lData)">
                                            <ibm-icon-time size="16" class="mr-2"></ibm-icon-time>
                                            <span>Do later</span>
                                          </button> -->
                                          <button class="dropdown-item" (click)="copyToClipboard(lData.url)">
                                            <img src="https://cdn.trovve.com/trovve/Copy-link-light.svg"
                                              class="w-15 mr-2" alt="Copy file link">
                                            <span>Copy file link</span>
                                          </button>
                                          <button class="dropdown-item" (click)="openShareModal(lData)"
                                            *ngIf="lData.driveId && lData.driveId !== lData.keyId">
                                            <ibm-icon-share size="16" class="mr-2"></ibm-icon-share>
                                            <span>Share</span>
                                          </button>
                                          <button class="dropdown-item"
                                            *ngIf="!getExtension(lData.extension) && lData.extension !== 'documentLibrary' && !lData.driveId"
                                            (click)="editWeblink(lData, catgItem.id)">
                                            <ibm-icon-edit size="16" class="mr-2"></ibm-icon-edit>
                                            <span>Rename</span>
                                          </button>
                                          <button class="dropdown-item"
                                            *ngIf="lData.driveId && lData.extension !== 'documentLibrary'"
                                            (click)="openRenameModal(lData)">
                                            <ibm-icon-edit size="16" class="mr-2"></ibm-icon-edit>
                                            <span>Rename</span>
                                          </button>
                                          <button class="dropdown-item"
                                            *ngIf="lData.driveId && lData.siteId && lData.extension === 'documentLibrary'"
                                            (click)="openRenameModal(lData)">
                                            <ibm-icon-edit size="16" class="mr-2"></ibm-icon-edit>
                                            <span>Rename</span>
                                          </button>
                                          <button class="dropdown-item" (click)="delTeamItem=lData">
                                            <ibm-icon-unlink size="16" class="mr-2 icon-14"></ibm-icon-unlink>
                                            <span>Unlink</span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ng-template>
                          </ul>
                          <div class="my-2"
                            *ngIf="catgItem.noOfItems === 0 && !isSearchApplied && !isTeamDataLoading && !isDriveCategoryLoading && !isLoadingTeamDrive">
                            <p class="f-size-14 text-center mb-0">
                              No links added in this category.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
                <div class="mt-5"
                  *ngIf="noMatchingRecentSearch && isSearchApplied && !isTeamDataLoading && !isDriveCategoryLoading && !isLoadingTeamDrive">
                  <h2 class="text-center text-vf-dark font-weight-semibold f-size-14">
                    No results found.
                  </h2>
                  <p class="f-size-13 text-center pb-5 text-vf-light font-weight-medium">
                    We can't find anything matching your search terms.
                  </p>
                </div>
                <div class="mt-5"
                  *ngIf="teamDriveCategoryData.length === 0 && !isSearchApplied && !isTeamDataLoading && !isDriveCategoryLoading && !isLoadingTeamDrive">
                  <h2 class="text-center text-vf-dark font-weight-semibold f-size-14">
                    Organize your content effectively using categories.
                  </h2>
                  <p class="f-size-13 text-center pb-5 text-vf-light font-weight-medium">
                    <a href="javascript:;" (click)="addNewCategory()"
                      class="text-blue-link cursor-pointer text-decoration-none">+ Add a category</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="tab-pane files-list" [ngClass]="{'active':  currentTab === 3}" role="tabpanel"
              id="SharePoint-files" aria-labelledby="SharePoint-files-tab">
              <perfect-scrollbar [config]="config">
                <div class="px-3 mt-20">
                  <div [hidden]="!isSharePointSitesLoading" class="my-10">
                    <div class="skeleton skeleton-tile"></div>
                  </div>
                  <div class="card-section"
                    *ngIf="sharePointSitesData.length > 0 && !isSharePointSitesLoading && !noResultFound">
                    <ul class="list-group text-medium project-file-list-group px-0">
                      <ng-template ngFor let-i="index" let-item [ngForOf]="sharePointSitesData">
                        <li class="list-group-item cursor-pointer d-flex" *ngIf="item.isShow"
                          (click)="goToFolderFromSharePoint($event, item)">
                          <div class="card-wrapper">
                            <div class="col d-flex px-0 justify-content-center">
                              <img class="text-center w-15"
                                src="https://cdn.trovve.com/vfapp/images/app-icons/SharePoint.svg">
                            </div>
                            <div class="col-11 pl-1">
                              <div class="row ml-0 flex-nowrap">
                                <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14 font-weight-500"
                                  href="javascript:;">
                                  {{item.displayName}}
                                </a>
                              </div>
                            </div>
                            <div class="col d-flex px-0 justify-content-end">
                              <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"></lucide-icon>
                            </div>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                  <div class="mt-5" *ngIf="!isSharePointSitesLoading && noResultFound">
                    <h2 class="text-center text-vf-dark font-weight-semibold f-size-14">
                      No results found.
                    </h2>
                    <p class="f-size-13 text-center mb-0 text-vf-light font-weight-medium">
                      We can't find anything matching your search terms.
                    </p>
                  </div>
                </div>
              </perfect-scrollbar>
            </div>
          </div>
          <div class="d-flex mt-4 d-flex cursor-pointer bg-pure-white rounded-12 border p-2 mx-20 justify-content-start" *ngIf="!isAccLinked">
            <div class="row mx-0 d-flex align-items-start w-100">
              <div class="col-auto px-2 py-1 border rounded-8">
                  <img alt="MSoft" class="w-10"
                      src="https://cdn.trovve.com/vfapp/images/microsoft-logo.svg">
              </div>
              <div class="col text-left align-item-center mt-1 mx-2 pr-0 pl-3">
                  <div class="row mb-1">
                      <div class="f-size-14 text-vf-dark letter-space-0">
                          <span class="font-weight-medium">Authorize Microsoft 365 Access</span>
                      </div>
                  </div>
                  <div class="row">
                      <span class="text-vf-light f-size-12">To give Trovve access to files, channels, and meetings</span>
                  </div>
              </div>
              <div class="w-auto p-1 align-self-center">
                  <button class="btn cancel-btn rounded-8 f-size-14 px-2 d-flex" (click)="relink()" 
                      style="box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.03), 0px 1px 3px 0px rgba(0, 0, 0, 0.04);">
                      <ibm-icon-ibm-security size="16" class="mr-2 icon-14 pb-02"></ibm-icon-ibm-security>
                      <span>Authorize</span>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<vf-delete-popup [entity]="'Link'" [isOpenFromSlider]="true" [entityObj]="delQLinkItem"
  (okClick)="okQuickLinkBtnClick($event)">
</vf-delete-popup>
<vf-delete-popup [entity]="'Category'" [isOpenFromSlider]="true" [entityObj]="delDriveCategoryItem"
  (okClick)="okDriveCategoryBtnClick($event)">
</vf-delete-popup>

<div class="modal file-filter-modal" id="filterFiles" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable justify-content-start px-4">
    <div class="modal-content bg-gray box-shadow">
      <div class="modal-header d-block border-0 pb-0 pt-3">
        <div class="row">
          <div class="col-sm-8 pr-0 align-self-center">
            <label class="f-size-16 text-vf-dark font-weight-bold cursor-pointer">Filters</label>
          </div>
          <div class="col-sm-4 pl-1">
            <div class="float-right d-flex justify-content-end text-right w-100 h-100">
              <a href="javascript:;" type="button" (click)="clearFilters()"
                class="float-right text-vf-dark text-center text-medium modal-close" data-dismiss="modal"
                aria-label="Close">
                <span class="f-size-13 blue-txt">Clear</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <button class="btn collapse-btn p-0 d-flex" data-toggle="collapse" data-target="#act_type" #typeEle>
            <lucide-icon [name]="typeEle.getAttribute('aria-expanded') ==='true' ? 'chevron-down' : 'chevron-up'" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon><label
              class="f-size-14 text-medium cursor-pointer text-none mb-0 font-weight-semibold">Type</label>
          </button>
          <div id="act_type" class="collapse show">
            <div class="my-10 custom-control pl-1 d-flex flex-column align-items-start">
              <div class="custom-control custom-checkbox custom-checkbox-success">
                <input type="checkbox" id="Word" name="Word" [checked]="isWordChecked" class="custom-control-input"
                  (change)="typeChanged('word')">
                <label class="custom-control-label pt-1 text-none f-size-14" for="Word">Word</label>
              </div>
              <div class="custom-control custom-checkbox custom-checkbox-success">
                <input type="checkbox" id="Excel" name="Excel" [checked]="isExcelChecked" class="custom-control-input"
                  (change)="typeChanged('excel')">
                <label class="custom-control-label pt-1 text-none f-size-14" for="Excel">Excel</label>
              </div>
              <div class="custom-control custom-checkbox custom-checkbox-success">
                <input type="checkbox" id="PP" name="PP" [checked]="isPPChecked" class="custom-control-input"
                  (change)="typeChanged('pp')">
                <label class="custom-control-label pt-1 text-none f-size-14" for="PP">Powerpoint</label>
              </div>
              <div class="custom-control custom-checkbox custom-checkbox-success">
                <input type="checkbox" id="PDF" name="PDF" [checked]="isPDFChecked" class="custom-control-input"
                  (change)="typeChanged('pdf')">
                <label class="custom-control-label pt-1 text-none f-size-14" for="PDF">PDF</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Link Modal-->
<div bsModal #addEditWeblinkModal="bs-modal" class="modal fade trovve-sm-modal" id="AddLink" tabindex="-1"
  [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content bg-popup box-shadow-popup border-all">
      <div class="modal-header d-block border-bottom p-0 pb-2">
        <div class="row">
          <div class="col-sm-6 pr-0 align-self-center text-uppercase font-weight-medium text-vf-dark f-size-12">
            {{ groupLinkObj.id ? 'Edit weblink' : 'Add new weblink'}}
          </div>
          <div class="col-sm-6">
            <button type="button" class="float-right d-flex modal-close-icon" (click)="closeAddEditWeblinkModal()"
              aria-label="Close">
              <ibm-icon-close size="16"></ibm-icon-close>
            </button>
          </div>
        </div>
      </div>
      <form #addEditWeblinkForm="ngForm" novalidate>
        <div class="modal-body p-0 py-20 mr-0">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Type name" required name="linkName"
                  [(ngModel)]="groupLinkObj.name">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="URL" required name="linkUrl"
                  [(ngModel)]="groupLinkObj.url" [ngClass]="{'is-invalid': isInvalidUrl}">
                <span *ngIf="isInvalidUrl" class="invalid-feedback text-right">Invalid url</span>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer text-center d-flex p-0">
        <button
          class="btn cancel-btn mr-2 f-size-14 rounded-8 hover-shadow py-10 bg-pure-white font-weight-normal text-body-alt w-100"
          (click)="closeAddEditWeblinkModal()">Cancel
        </button>
        <button class="btn btn-black f-size-14 rounded-8 hover-shadow py-10 font-weight-normal w-100"
          [disabled]="!addEditWeblinkForm.form.valid || isSaving" (click)="saveWeblink()">{{ groupLinkObj.id ? 'Save' :
          'Create weblink'}}
        </button>
      </div>
    </div>
  </div>
</div>

<vf-delete-popup [entity]="'Item'" [isOpenFromSlider]="false" [entityObj]="delTeamItem" (okClick)="okBtnClick($event)" [actionName]="'Unlink'">
</vf-delete-popup>

<vf-file-selector [showPopup]="showFilePopup" [isSingleSelect]="isSingleSelectMode" [showFolderOnly]="isShowFolderOnly" [canSelectLibrary]="true"
  (selectedItems)="onSelectItem($event)" (onClose)="onCloseFileSelector()"></vf-file-selector>

<vf-delete-popup [entity]="'Item'" [isOpenFromSlider]="true" [entityObj]="delFileItem"
  (okClick)="okFileBtnClick($event)">
</vf-delete-popup>

<div bsModal #deleteMultipleFilesDeletePopup="bs-modal" class="modal fade center-modal trovve-sm-modal"
  id="fl_deleteMultipleFilesDeletePopup" tabindex="-1" [config]="{backdrop: 'static',  keyboard: false}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mw-400">
    <div class="modal-content login-modal bg-popup box-shadow-popup border-all">
      <div class="modal-body text-center pb-4">
        <div class="text-center">
          <div class="py-2">
            <ibm-icon-trash-can size="20" class="rounded-circle border p-10"></ibm-icon-trash-can>
          </div>
          <h1 class="f-size-20 tk-montserrat text-vf-dark font-weight-semibold mb-10 mt-20">Delete {{ noOfSelectedItems }} items?</h1>
          <p class="f-size-14 text-medium font-weight-normal mb-0">This action cannot be undone.</p>
        </div>
      </div>
      <div class="modal-footer text-center d-flex p-0">
        <button
          class="btn cancel-btn mr-2 f-size-14 rounded-8 py-10 bg-pure-white font-weight-normal text-vf-dark w-100"
          (click)="closeMultipleFileDeletePopup()">Cancel
        </button>
        <button type="button" (click)="deleteMultipleFiles()" [disabled]="isDeleting"
          class="btn btn-black rounded-8 py-10 w-100">Delete
        </button>
      </div>
    </div>
  </div>
</div>
<vf-info-popup [information]="information" [isShow]="isShowInfoPopup" (okClick)="okInfoPopupClicked($event)"></vf-info-popup>
<vf-modal-shell #fileLoadErrorShell
  [failure]="true"
  title="Couldn't load files"
  [message]="fileLoadError?.message"
  [cancelLabel]="fileLoadError?.cancelLabel"
  (cancelClick)="closeFileLoadError()">
</vf-modal-shell>